import React from 'react';
import './preview.scss';

/**
 * AOPS-59688/ AOPS-60315: PreviewModeFrames component.
 *
 * This component renders the frames for the preview mode banner.
 * The frames are separated into right, left, and bottom sections.
 * This separation allows for better organization and styling of the
 * preview mode banner as part of the TDTK local navigation header.
 * This component will not affect any other UI component container's responsiveness
 * or break any other styles for any other component.
 *
 */

const PreviewModeFrames: React.FC = () => {
  return (
    <>
      <div className='preview-mode-frame-right'> </div>
      <div className='preview-mode-frame-left'> </div>
      <div className='preview-mode-frame-bottom'> </div>
    </>
  );
};

export default PreviewModeFrames;
